import { ValidationStatuses } from '@sunwebgroup/uds-ui/fields/base-field'
import * as React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

export function useStatus({
  name,
  required = false,
  validations,
  shouldMarkValidStatus = (value: string) => {
    return Boolean(value?.trim())
  },
}: {
  name: string
  required?: boolean
  validations?: Record<string, (value: any) => boolean>
  shouldMarkValidStatus?: (value: any) => boolean
}) {
  const { formState, getFieldState } = useFormContext()
  const { isDirty, isTouched, error } = getFieldState(name, formState)
  const [wasInteracted, setWasInteracted] = React.useState(false)
  const value = useWatch({ name })
  const isValid = validate(value, validations)
  const markValidStatus = shouldMarkValidStatus ? shouldMarkValidStatus(value) : true

  React.useEffect(() => {
    if (isDirty && !wasInteracted) {
      setWasInteracted(true)
    }
  }, [isDirty, wasInteracted])

  let result: ValidationStatuses = 'default'
  if (!value) {
    result = 'default'
  }

  if (!value && required && error?.type === 'required') {
    result = 'error'
  }

  if (isTouched && !isValid && error) {
    result = 'error'
  }

  if (wasInteracted && isValid && markValidStatus) {
    result = 'success'
  }
  return result
}

function validate(value?: string, validations: Record<string, (value: any) => boolean> = {}) {
  return validations ? Object.entries(validations).every(([_, validation]) => validation(value)) : true
}
